'use client';

import { useEffect, useState } from 'react';
import dynamic from 'next/dynamic';

const SiteChatbot = dynamic(() =>
  import('./SiteChatbot').then((m) => m.SiteChatbot),
);

/* 챗봇 청크가 퍼블릭 페이지 first-load JS에 포함되지 않도록
 * 하이드레이션 이후 idle 시점에 로드한다 (SecHero 비디오 지연과 동일 패턴) */
export function DeferredSiteChatbot() {
  const [mount, setMount] = useState(false);

  useEffect(() => {
    const w = window as Window &
      typeof globalThis & {
        requestIdleCallback?: (cb: () => void) => number;
        cancelIdleCallback?: (id: number) => void;
      };
    let idleId: number | null = null;
    let timeoutId: ReturnType<typeof setTimeout> | null = null;

    if (typeof w.requestIdleCallback === 'function') {
      idleId = w.requestIdleCallback(() => setMount(true));
    } else {
      timeoutId = setTimeout(() => setMount(true), 200);
    }

    return () => {
      if (idleId !== null && typeof w.cancelIdleCallback === 'function') {
        w.cancelIdleCallback(idleId);
      }
      if (timeoutId !== null) clearTimeout(timeoutId);
    };
  }, []);

  return mount ? <SiteChatbot /> : null;
}
